import React, { useState } from "react";
import SVGIcon from "web/react/components/svg-icon/svg-icon";
import { GenericTextInput, GenericTextInputProps } from "web/react/emo/inputs";
import styles from "./password-input.module.css";

export interface PasswordInputProps extends Omit<GenericTextInputProps, "type"> {
    value?: string;
}

export function PasswordInput({ error, value, ...props }: PasswordInputProps): JSX.Element {
    const [isShown, setisShown] = useState(false);

    return (
        <div className={styles.contentWrapper}>
            <GenericTextInput
                type={isShown ? "text" : "password"}
                error={error}
                value={value}
                {...props}
                icon={
                    <div className={styles.showIcon} onClick={() => setisShown(!isShown)}>
                        <SVGIcon name={isShown ? "show-on" : "show-off"} />
                    </div>
                }
            />
        </div>
    );
}
